require('./vendor/bootstrap')

//require('jquery-migrate')
require('devbridge-autocomplete')
require('bootstrap-select')
require('bootstrap-submenu')
require('bootstrap-notify')
window.WOW = require('./vendor/wow.min').WOW
window.Dropzone = require('dropzone')
require('slick-carousel')
require('html5shiv')
require('./vendor/ie10-viewport-bug-workaround')
require('jquery.easing')
require('filterizr')
require('magnific-popup')
require('jquery.mb.ytplayer')
require('jquery-mousewheel')
require('malihu-custom-scrollbar-plugin')
require('./vendor/jquery.scrollUp')
require('leaflet')
require('./vendor/leaflet.markercluster')
require('./vendor/leaflet-providers')
require('bootstrap-autocomplete')
require('leaflet-sidebar-v2')
require('./vendor/L.Control.Locate.min')
require('./vendor/maps')
require('./vendor/rangeslider')
require('./vendor/sidebar')
require('./vendor/app')
require('sweetalert2')
require('select2')
require('jquery-mask-plugin')
require('./custom/vendor/jquery.mask.min')
require('./custom/vendor/jquery.maskMoney.min')

require('./RIFTHelper')

require('./echo')

require('./custom/custom')
